
import { mapMutations, mapState } from 'vuex';
import Product from '@/components/shop/product.vue';

export default {
  name: 'ProductSliderItem',

  components: {
    Product,
  },

  props: {
    productId: {
      type: Number,
      required: true,
    },
  },

  async fetch() {
    const { data } = await this.$wc.products({ id: this.productId });
    if (data) {
      this.addProduct(data);
    } else {
      return this.$nuxt.error({
        statusCode: 404,
      });
    }
  },

  computed: {
    ...mapState(['products']),

    product() {
      return this.products.find((p) => p.id === this.productId);
    },

    image() {
      return this.product && this.product.images && this.product.images.length
        ? this.product.images[0]
        : null;
    },
  },

  methods: {
    ...mapMutations(['addProduct']),
  },
};
